import PrimeVue from 'primevue/config'
//theme
import 'primevue/resources/themes/lara-light-indigo/theme.css'

//core
import 'primevue/resources/primevue.min.css'

//icons
import 'primeicons/primeicons.css'

//components
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Divider from 'primevue/divider'
import Card from 'primevue/card'
import InlineMessage from 'primevue/inlinemessage'
import Toast from 'primevue/toast'
import ProgressSpinner from 'primevue/progressspinner'
import SideBar from 'primevue/sidebar'
import PanelMenu from 'primevue/panelmenu'
import MenuBar from 'primevue/menubar'
import Avatar from 'primevue/avatar'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Chip from 'primevue/chip'
import Dropdown from 'primevue/dropdown'
import Textarea from 'primevue/textarea'
import ConfirmPopup from 'primevue/confirmpopup'
import ConfirmDialog from 'primevue/confirmdialog'
import Tooltip from 'primevue/tooltip'
import InputSwitch from 'primevue/inputswitch'
import AutoComplete from 'primevue/autocomplete'
import MultiSelect from 'primevue/multiselect'
import Dialog from 'primevue/dialog'
import Steps from 'primevue/steps'
import Calendar from 'primevue/calendar'
import Fieldset from 'primevue/fieldset'
import Skeleton from 'primevue/skeleton'
import InputNumber from 'primevue/inputnumber'
import Breadcrumb from 'primevue/breadcrumb'
import Password from 'primevue/password'
import OverlayPanel from 'primevue/overlaypanel'
import TieredMenu from 'primevue/tieredmenu'
import Chips from 'primevue/chips'
import ProgessBar from 'primevue/progressbar'
import SelectButton from 'primevue/selectbutton'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'

import { App } from 'vue'
import Listbox from 'primevue/listbox'
import Checkbox from 'primevue/checkbox'
import Tag from 'primevue/tag'
import Toolbar from 'primevue/toolbar'
import FileUpload from 'primevue/fileupload'
import SplitButton from 'primevue/splitbutton'

export const PrimeVuePlugin = {
  install(app: App<Element>) {
    app.use(PrimeVue, {
      ripple: false,
      locale: {
        dayNames: [
          'Domingo',
          'Lunes',
          'Martes',
          'Miercoles',
          'Jueves',
          'Viernes',
          'Sabado',
        ],
        dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre',
        ],
        monthNamesShort: [
          'Ene',
          'Feb',
          'Mar',
          'Abr',
          'May',
          'Jun',
          'Jul',
          'Ago',
          'Sep',
          'Oct',
          'Nov',
          'Dic',
        ],
        today: 'Hoy',
        weekHeader: 'Wk',
        clear: 'limpiar',
        firstDayOfWeek: 1,
        dateFormat: 'mm/dd/yy',
      },
    })
    app.component('Button', Button)
    app.component('InputText', InputText)
    app.component('Divider', Divider)
    app.component('Card', Card)
    app.component('InlineMessage', InlineMessage)
    app.component('Toast', Toast)
    app.component('ProgressSpinner', ProgressSpinner)
    app.component('SideBar', SideBar)
    app.component('PanelMenu', PanelMenu)
    app.component('MenuBar', MenuBar)
    app.component('Avatar', Avatar)
    app.component('DataTable', DataTable)
    app.component('Column', Column)
    app.component('Chip', Chip)
    app.component('Dropdown', Dropdown)
    app.component('Textarea', Textarea)
    app.component('ConfirmPopup', ConfirmPopup)
    app.component('ConfirmDialog', ConfirmDialog)
    app.component('InputSwitch', InputSwitch)
    app.component('AutoComplete', AutoComplete)
    app.component('MultiSelect', MultiSelect)
    app.component('Dialog', Dialog)
    app.component('Steps', Steps)
    app.component('Fieldset', Fieldset)
    app.component('Calendar', Calendar)
    app.component('Skeleton', Skeleton)
    app.component('InputNumber', InputNumber)
    app.component('Breadcrumb', Breadcrumb)
    app.component('Listbox ', Listbox)
    app.component('Checkbox ', Checkbox)
    app.component('Tag ', Tag)
    app.component('Toolbar ', Toolbar)
    app.component('FileUpload', FileUpload)
    app.component('Password', Password)
    app.component('OverlayPanel', OverlayPanel)
    app.component('TieredMenu', TieredMenu)
    app.component('Chips', Chips)
    app.component('SplitButton', SplitButton)
    app.component('ProgessBar', ProgessBar)
    app.component('SelectButton', SelectButton)
    app.component('TabView', TabView)
    app.component('TabPanel', TabPanel)
    app.directive('tooltip', Tooltip)
  },
}
